import { DependentDto } from '../types';

export const stripErrorMessage = (message?: string) => {
  if (!message) {
    return message;
  }

  let result = message;
  new Map([
    [/^base:\s*/, ''],
    [/~base:\s*/, '~'],
    [/\s+base:\s*/, ''],
  ]).forEach((value, key) => {
    result = result.replace(key, value);
  });

  return result;
};

export const findDependent = (
  dependents: DependentDto[],
  dependentId: string
) => dependents.find((dependent) => dependent.id.toString() === dependentId)!;
